import { render, staticRenderFns } from "./manualReward.vue?vue&type=template&id=02c0d9b5&scoped=true"
import script from "./manualReward.vue?vue&type=script&lang=js"
export * from "./manualReward.vue?vue&type=script&lang=js"
import style0 from "./manualReward.vue?vue&type=style&index=0&id=02c0d9b5&prod&lang=scss"
import style1 from "./manualReward.vue?vue&type=style&index=1&id=02c0d9b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c0d9b5",
  null
  
)

export default component.exports